import Vue from 'vue';

Vue.filter('number', function (value) {
    if(!value) {
        return value;
    }
    return value.toLocaleString('en-US', {maximumFrationDigits: 2});
});
